import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {States} from "../../shared/config/constant.module";
import template from './productionReport.tpl.html';
import {Plant} from "../../models/navigation";
import {StateParams} from "../../common";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import {apsEvents} from "../../shared/dto/aps.events";
import { apsViewModels } from '../../shared/dto/APS.ViewModels';

let requires = [LoaderServiceName, ReportServiceName, AuthDataServiceName, 
  NavigationServiceName];
  
interface ProductionReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;
  results: apsViewModels.ProductionReport;
}

export interface ProductionReportParams extends StateParams {
  reportPlantId: string;
  reportDate: string;
}

class ProductionReportCtrl implements ProductionReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;
  results: apsViewModels.ProductionReport;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  authDataService: AuthDataService;
  $q: angular.IQService;
  $location: angular.ILocationService;
  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;
  private $stateParams: ProductionReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: ProductionReportParams,
    $location: angular.ILocationService,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    $q: angular.IQService) {

    var vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.authDataService = authDataService;
    this.$q = $q;

    this.reportDate = moment().clone().startOf('day').toDate();
    this.generateReport();
    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;

    });

    loaderService.loadingPromise(promise);

  }

  generateReport(): angular.IPromise<any> {
    var promise = this.runReport();
    this.loaderService.loadingPromise(promise);
    return promise;
  }
  private runReport(): angular.IPromise<any> {

    var plantId = this.$location.search().plantId;
    var shopId =  this.$location.search().shopId;
    var userId =  this.$location.search().userId;
    var scheduleOn = this.$location.search().scheduleOn;
    var checklistInstanceId = this.$location.search().checklistInstanceId;

    return this.reportService.getProductionReport(plantId, shopId, userId, scheduleOn, checklistInstanceId).then(reportItem => {
      this.results = reportItem;
    });

  }
 }

export default angular.module('aps.controller.productionReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.PRODUCTION_REPORT,
      url: '/admin/reports/productionReport',
      params: {
        reportDate: {dynamic: true},
        reportPlantId: {dynamic: true}
      },
      controller: 'ProductionReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Production Report'
      }
    });
  })
  .controller('ProductionReportCtrl', ProductionReportCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/productionReport.controller.ts